import catalog from './catalog';
import productManage from './_admin-product-manage';
import userManager from './_admin-user-manage';
import organizationManager from './_admin-organization-manage';
import supplierReport from './report';
import dashboard from './dashboard';
import termsAndConditions from './termsAndConditions';

export default {
  catalog,
  productManage,
  userManager,
  organizationManager,
  supplierReport,
  dashboard,
  termsAndConditions,
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/index.js